import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { Claims } from '@core/authentication/claims';
import { aggregator } from '@env/aggregator/aggregator';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
  private _aggregatorDefaultCountry =
    aggregator.settings.claims.defaults.country;
  private _country!: Claims.Country;
  private _locale!: string;
  constructor(private oauthService: MsalService) {}

  private get claims(): any {
    return this.oauthService.instance.getActiveAccount()?.idTokenClaims;
  }

  public get userId(): string {
    return this.claims?.extension_UserId;
  }

  public get userDisplayName(): string {
    return this.claims?.name;
  }

  public get firstName(): string | null {
    return this.claims?.given_name;
  }

  public get lastName(): string | null {
    return this.claims?.family_name;
  }

  public get country(): Claims.Country {
    if (!this._country) {
      this._country =
        (this.claims?.country
          ? Claims.Country.toEnum(this.claims?.country)
          : null) || this._aggregatorDefaultCountry;
    }
    return this._country;
  }

  public get userRole(): Claims.UserRoles | null {
    const role = this.claims?.roleName;
    return role === undefined ? null : (role as Claims.UserRoles);
  }

  public get isAustralia(): boolean {
    return this.country === Claims.Country.Australia;
  }

  public get locale(): string {
    if (!this._locale) {
      this._locale = Claims.Country.toLocale(this.country);
    }
    return this._locale;
  }

  public get portfolioId(): string {
    return this.claims?.extension_Portfolio;
  }
}
